import { render, staticRenderFns } from "./BankSoalList.vue?vue&type=template&id=a439ccb8&scoped=true"
import script from "./BankSoalList.vue?vue&type=script&lang=js"
export * from "./BankSoalList.vue?vue&type=script&lang=js"
import style0 from "./BankSoalList.vue?vue&type=style&index=0&id=a439ccb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a439ccb8",
  null
  
)

export default component.exports